import each from 'lodash/each';
import isEmpty from 'lodash/isEmpty';

export default {
  SAVE_METADATA(state, data) {
    state.metaData = data;
  },
  SAVE_MATCHESDATA(state, data) {
    state.matchesData = data;
    state.resultsLoaded = true;
  },
  SELECT_SPORT(state, sport) {
    if (typeof sport === 'undefined') {
      const metaSportsIndex = Object.keys(state.metaData.sports);
      if (metaSportsIndex.indexOf(state.selectedSport.id) < 0) {
        state.selectedSport = state.metaData.sports[metaSportsIndex[0]];
      }
    } else {
      state.selectedSport = sport;
    }
  },
  FILTER_RESULTS(state) {
    const categoriesArr = Object.keys(state.matchesData.categories)
      .map(key => state.matchesData.categories[key]);
    const tournamentsArr = Object.keys(state.matchesData.tournaments)
      .map(key => state.matchesData.tournaments[key]);
    const categories = categoriesArr
      .filter(category => category.idSport === state.selectedSport.id);
    const tournaments = tournamentsArr
      .filter(tournament => tournament.idSport === state.selectedSport.id);
    const matches = state.matchesData.matches
      .filter(match => match.idSport === state.selectedSport.id);

    if (isEmpty(categories)) {
      state.filteredResults = [];
      return;
    }

    state.filteredResults = categories;
    each(state.filteredResults, (category) => {
      category.tournaments = [];
      each(tournaments, (tournament) => {
        if (tournament.idCategory === category.id) {
          tournament.matches = [];
          each(matches, (match) => {
            if (match.idTournament === tournament.id) {
              const resultsMapper = state.resultsMap[state.selectedSport.providerId]
                || state.resultsMap.default;
              if (resultsMapper) {
                const mappedResults = {};
                each(state.resultsMap[state.selectedSport.providerId], (mapResult) => {
                  mappedResults[mapResult.providerId] = {
                    value: '--',
                    providerId: mapResult.providerId,
                  };
                  if (!isEmpty(match.results)) {
                    each(match.results, (result) => {
                      if (mapResult.providerId === result.providerId) {
                        mappedResults[result.providerId] = match.results[result.providerId];
                      }
                    });
                  }
                });
                if (match.name !== null) {
                  if (match.name.split('-').length === 2) {
                    match.results = mappedResults;
                    tournament.matches.push(match);
                  }
                }
              }
            }
          });
          if (!isEmpty(tournament.matches)) {
            category.tournaments.push(tournament);
          }
        }
      });
    });
  },
  SAVE_DATE(state, utcDate) {
    state.utcDate = utcDate;
  },
  SAVE_TRANSLATIONS(state, translations) {
    state.translations = translations;
  },
  SAVE_COMPANY_SETTINGS(state, payload) {
    state.companySettings = payload;
  },
};
